import { useTranslation } from 'react-i18next';

import { ChevronRight } from 'lucide-react';

import { Max } from '@/components/contacts-icons/max.tsx';
import { Telegram } from '@/components/contacts-icons/telegram.tsx';

import { IconWithBackground } from '@/lib/shadcn/components/ui/icon-with-background/icon-with-background';
import { Stack } from '@/lib/shadcn/components/ui/stack/stack';
import { tileButtonVariants } from '@/lib/shadcn/components/ui/tile-button/tile-button-variants';

import { Email } from '../contacts-icons/email';
import { Phone } from '../contacts-icons/phone';
import { Typography } from '../typography/typography';

export function ContactUsLinks() {
  const { t } = useTranslation();

  return (
    <>
      <a
        href="https://t.me/zabota_2meterguide"
        target="_blank"
        className={tileButtonVariants({
          background: 'light',
          paddingSize: 'large',
        })}
      >
        <IconWithBackground icon={<Telegram />} size="sm" iconSize="lg" />
        <Stack className="w-full">
          <Typography.small1 className="text-slate-400">
            {t('contact-us.contacts.telegram')}
          </Typography.small1>
          <Typography.p4 className="text-slate-500">@zabota_2meterguide</Typography.p4>
        </Stack>
        <IconWithBackground variant="secondary" icon={<ChevronRight />} size="lg" />
      </a>
      <a
        href="tel:+79052407010"
        target="_blank"
        className={tileButtonVariants({
          background: 'light',
          paddingSize: 'large',
        })}
      >
        <IconWithBackground icon={<Max />} size="sm" iconSize="lg" />
        <Stack className="w-full">
          <Typography.small1 className="text-slate-400">
            {t('contact-us.contacts.max')}
          </Typography.small1>
          <Typography.p4 className="text-slate-500">+7 905 240-70-10</Typography.p4>
        </Stack>
        <IconWithBackground variant="secondary" icon={<ChevronRight />} size="lg" />
      </a>
      <a
        href="tel:+79052407010"
        target="_blank"
        className={tileButtonVariants({
          background: 'light',
          paddingSize: 'large',
        })}
      >
        <IconWithBackground icon={<Phone />} size="sm" iconSize="lg" />
        <Stack className="w-full">
          <Typography.small1 className="text-slate-400">
            {t('contact-us.contacts.phone')}
          </Typography.small1>
          <Typography.p4 className="text-slate-500">+7 905 240-70-10</Typography.p4>
        </Stack>
        <IconWithBackground variant="secondary" icon={<ChevronRight />} size="lg" />
      </a>
      <a
        href="mailto:dialog@dvuhmetrovigid.ru"
        target="_blank"
        className={tileButtonVariants({
          background: 'light',
          paddingSize: 'large',
        })}
      >
        <IconWithBackground icon={<Email />} size="sm" iconSize="lg" />
        <Stack className="w-full">
          <Typography.small1 className="text-slate-400">
            {t('contact-us.contacts.email')}
          </Typography.small1>
          <Typography.p4 className="text-slate-500">
            dialog@dvuhmetrovigid.ru
          </Typography.p4>
        </Stack>
        <IconWithBackground variant="secondary" icon={<ChevronRight />} size="lg" />
      </a>
    </>
  );
}
